import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "content-container" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "margin-top-8px" }
const _hoisted_4 = { class: "input-container" }
const _hoisted_5 = { class: "input-container" }
const _hoisted_6 = { class: "input-container" }
const _hoisted_7 = { class: "input-container" }
const _hoisted_8 = { class: "input-container" }
const _hoisted_9 = { class: "input-container" }
const _hoisted_10 = { class: "span-radio" }
const _hoisted_11 = { class: "span-radio" }
const _hoisted_12 = {
  key: 0,
  class: "input-container"
}
const _hoisted_13 = {
  key: 1,
  class: "input-container"
}
const _hoisted_14 = {
  key: 2,
  class: "input-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DropDown = _resolveComponent("DropDown")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_ReglePastille = _resolveComponent("ReglePastille")!
  const _component_RadioBox = _resolveComponent("RadioBox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('outils.compteur.step.two.title.representant.partenaire')), 1),
    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('outils.compteur.step.one.two.subtitle.check')), 1),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", null, _toDisplayString(_ctx.$t('outils.compteur.step.two.civilite')), 1),
      _createVNode(_component_DropDown, {
        list: _ctx.listCivilite,
        selectedItem: _ctx.selectedCivilite,
        display: _ctx.displayCivilite,
        onSelect: _ctx.setCivilite,
        class: "drop-down",
        label: _ctx.$t('outils.compteur.step.two.civilite')
      }, null, 8, ["list", "selectedItem", "display", "onSelect", "label"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", null, _toDisplayString(_ctx.$t('outils.compteur.step.two.nom.representant')), 1),
      _withDirectives(_createElementVNode("input", {
        class: "text-input",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.nomRepresentant) = $event))
      }, null, 512), [
        [_vModelText, _ctx.nomRepresentant]
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", null, _toDisplayString(_ctx.$t('outils.compteur.step.two.prenom.representant')), 1),
      _withDirectives(_createElementVNode("input", {
        class: "text-input",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.prenomRepresentant) = $event))
      }, null, 512), [
        [_vModelText, _ctx.prenomRepresentant]
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", null, _toDisplayString(_ctx.$t('outils.compteur.step.two.date.naissance.representant')), 1),
      _createVNode(_component_DatePicker, {
        class: "datepicker",
        onSetDate: _ctx.setDateNaissance,
        dateValue: _ctx.dateNaissanceRepresentant,
        label: _ctx.$t('outils.compteur.step.two.date.naissance.representant')
      }, null, 8, ["onSetDate", "dateValue", "label"])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", null, _toDisplayString(_ctx.$t('outils.compteur.step.two.email.representant')), 1),
      _withDirectives(_createElementVNode("input", {
        class: _normalizeClass(["text-input", {'no-valid': !_ctx.isMailValid}]),
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.mailRepresentant) = $event))
      }, null, 2), [
        [_vModelText, _ctx.mailRepresentant]
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", null, [
        _createTextVNode(_toDisplayString(_ctx.$t('outils.compteur.step.two.adresse.representant')) + " ", 1),
        _createVNode(_component_ReglePastille, { cle: "outils.etape2AdresseConditionnelle" })
      ]),
      _createElementVNode("div", {
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setAdresseIdentique(true))),
        class: "margin-top-8px"
      }, [
        _createVNode(_component_RadioBox, {
          selected: _ctx.adresseIdentique,
          class: "cursor-pointer"
        }, null, 8, ["selected"]),
        _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('outils.compteur.step.two.adresse.identique')), 1)
      ]),
      _createElementVNode("div", {
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setAdresseIdentique(false)))
      }, [
        _createVNode(_component_RadioBox, {
          selected: !_ctx.adresseIdentique,
          class: "cursor-pointer"
        }, null, 8, ["selected"]),
        _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t('outils.compteur.step.two.adresse.differente')), 1)
      ])
    ]),
    (!_ctx.adresseIdentique)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("div", null, _toDisplayString(_ctx.$t('outils.compteur.step.two.adresse.postale')), 1),
          _withDirectives(_createElementVNode("input", {
            class: "text-input",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.adresseRepresentant) = $event))
          }, null, 512), [
            [_vModelText, _ctx.adresseRepresentant]
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.adresseIdentique)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createElementVNode("div", null, _toDisplayString(_ctx.$t('outils.compteur.step.two.code.postal')), 1),
          _withDirectives(_createElementVNode("input", {
            class: "text-input",
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.codePostalRepresentant) = $event)),
            type: "number",
            onKeypress: _cache[7] || (_cache[7] = ($event: any) => (_ctx.disableNegatif($event))),
            min: "0"
          }, null, 544), [
            [_vModelText, _ctx.codePostalRepresentant]
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.adresseIdentique)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("div", null, _toDisplayString(_ctx.$t('outils.compteur.step.two.ville')), 1),
          _withDirectives(_createElementVNode("input", {
            class: "text-input",
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.villeRepresentant) = $event))
          }, null, 512), [
            [_vModelText, _ctx.villeRepresentant]
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}